require('../../modules/es7.array.includes');
module.exports = require('../../modules/_core').Array.includes;



//////////////////
// WEBPACK FOOTER
// /Users/KCrisanto/Documents/dea-spms/node_modules/core-js/fn/array/includes.js
// module id = 158
// module chunks = 0